import { useRouterState } from "@tanstack/react-router";

export function useSupplierId() {
  const id = useRouterState({
    select(state) {
      const routeParams = state.matches[0]?.params;
      const idFromURL = routeParams && "supplierId" in routeParams ? routeParams.supplierId : undefined;
      if (idFromURL) {
        return idFromURL;
      }
      return undefined;
    },
  });
  return id;
}

export function useSupporterId() {
  const id = useRouterState({
    select(state) {
      const routeParams = state.matches[0]?.params;
      const idFromURL = routeParams && "supporterId" in routeParams ? routeParams.supporterId : undefined;
      if (idFromURL) {
        return String(idFromURL);
      }
      return undefined;
    },
  });
  return id;
}
